<template>
  <div>
    <div v-if="voucherType === 'oksusu'" class="exclamation-list">
      <h3 class="exclamation-hd">프로모션 주의 사항</h3>
      <ul>
        <li>3개월 간 4,000원 프로모션은 해당 이용권 유지 시에만 적용됩니다.</li>
        <li>할인 적용 여부는 최종 구매 페이지에서 확인 가능합니다.</li>
        <li>다른 이용권으로 변경 시 프르모션 혜택이 종료됩니다.</li>
        <li>이 프로모션은 현재 페이지에서 구매 시에만 적용 가능합니다.</li>
        <li>
          POOQ 이용권 페이지 내 동일한 금액의 동일한 이용권이더라도 프로모션
          상품이 아니므로 이용권 변경 시 프로모션 혜택은 종료됩니다.
        </li>
      </ul>
    </div>

    <div class="exclamation-list">
      <h3 class="exclamation-hd">서비스 이용 주의사항</h3>
      <ul>
        <li
          v-for="serviceCaution in CAUTIONS_FOR_SERVICE_IOS"
          :key="serviceCaution"
          v-html="getTextLinks(serviceCaution, CAUTIONS_FOR_SERVICE_LINK)"
        ></li>
      </ul>
    </div>

    <div class="exclamation-list">
      <h3 class="exclamation-hd">서비스 이용 권장사양</h3>
      <ul>
        <li
          v-for="caution in RECOMMENDATION_FOR_SERVICE"
          :key="caution"
          v-html="getTextBreaks(caution)"
        ></li>
      </ul>
    </div>

    <div class="exclamation-list">
      <h3 class="exclamation-hd">이용권 구매 주의 사항</h3>
      <ul>
        <li
          v-for="caution in CAUTIONS_FOR_PURCHASE"
          :key="caution"
          v-html="getTextLinks(caution, CAUTIONS_FOR_ANDROID_MO_WEB_LINK)"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed } from 'vue'
  import utils from '@/common/util/utils'
  import {
    CAUTIONS_FOR_PURCHASE,
    CAUTIONS_FOR_SERVICE_LINK,
    CAUTIONS_FOR_SERVICE,
    RECOMMENDATION_FOR_SERVICE,
    createCautionsForAndroidMoWeb,
    CAUTIONS_FOR_SERVICE_IOS,
  } from '@/components/lnb/voucher/voucher-text/const'
  import { getTextLinks } from '@/common/util/string-manipulation/get-text-links'
  import { getTextBreaks } from '@/common/util/string-manipulation/get-text-breaks'

  defineProps({
    voucherType: {
      type: String,
    },
  })

  const pgName = computed(() => utils.getPgName())
  const device = computed(() => utils.cookies.getDevice())
  const CAUTIONS_FOR_ANDROID_MO_WEB_LINK = createCautionsForAndroidMoWeb(
    pgName.value,
    device.value,
  )
</script>
